import { useCallback, useEffect, useState } from "react";
import { fetchAccountParticipationsMapped } from "../api/client.js";
import { hasMarketplaceJwtCredentials } from "../lib/wicoopProfileStorage.js";
import { ensureMarketplaceAccountHasPhone } from "../lib/telegramWebAppAuth.js";

export function useProfileParticipationsRows() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadTick, setReloadTick] = useState(0);

  const reload = useCallback(() => {
    setReloadTick((n) => n + 1);
  }, []);

  useEffect(() => {
    if (!hasMarketplaceJwtCredentials()) {
      setRows([]);
      setLoading(false);
      setError(null);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    (async () => {
      await ensureMarketplaceAccountHasPhone();
      if (cancelled) return;
      const list = await fetchAccountParticipationsMapped();
      if (!cancelled) setRows(Array.isArray(list) ? list : []);
    })()
      .catch((e) => {
        if (!cancelled) setError(e.message || "Ошибка загрузки");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [reloadTick]);

  return { rows, loading, error, reload };
}
